<template>
  <nav class="atlas">
    <MdSwitch v-if="$store.state.fold.back" class="front md-primary" v-model="$store.state.front">
      {{ frontLabel }}
    </MdSwitch>
    <div class="pages">
      <div
        v-for="page in $store.state.pages" :key="page.index"
        :class="pageClass(page)"
        :value="page.index"
        @click="setPage(page.index)"
      >
        {{ page.label }}
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    frontLabel() {
      return this.$store.state.front ? 'front' : this.$store.state.fold.back;
    }
  },
  methods: {
    pageClass(page) {
      return {
        active: this.$store.state.page === page.index,
        page: true
      };
    },
    setPage(index) {
      this.$store.commit('setPage', index);   
    }
  }
}
</script>

<style scoped>
  .atlas {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: stretch;
    margin: 0;
    gap: 4px;
  }
  .front ::v-deep .md-switch-container {
    order: 2;
  }
  .front ::v-deep .md-switch-label {
    order: 1;
    padding-right: 8px;
  }
  .front ::v-deep label {
    color: #427FED;
  }
  .pages {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-family: var(--font-family-balsamiq);
    font-size: 16px;
  }
  .page {
    position: relative;
    color: var(--text-bright);
    background-color: var(--surface-darker);
    border-radius: 0 12px 12px 0;
    padding: 4px 12px 4px 8px;
    cursor: pointer;
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
    text-align: center;
    min-width: 32px;
    line-height: 24px;
    border: none;
    filter: none;
  }
  .page.active {
    font-weight: bold;
    background-color: var(--green-lightest);
    color: var(--text-dark);
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  }

</style>
